// @flow
import React, { Suspense } from 'react';

import LoadingIndicator from '../../components/LoadingIndicator';

const DownloadApp = React.lazy(() => import('./index'));

const DownloadAppLoadable = () => (
  <div>
    <Suspense fallback={<LoadingIndicator />}>
      <DownloadApp />
    </Suspense>
  </div>
);

export default DownloadAppLoadable;
